declare global {
    interface Window {
        jQuery: any;
        marquee: any;
    }
}

export function initializeSlidingText(containerElement: HTMLElement | null): void {
    if (!containerElement) {
        return;
    }

    // Wait for jQuery and marquee plugin to be available
    const initMarquee = (): void => {
        const jQuery = (window as any).jQuery;
        if (typeof jQuery === 'undefined') {
            setTimeout(initMarquee, 100);
            return;
        }

        // Check if marquee plugin is available
        if (!jQuery.fn || typeof jQuery.fn.marquee === 'undefined') {
            setTimeout(initMarquee, 100);
            return;
        }

        // Give a small delay to ensure DOM is fully rendered
        setTimeout(() => {
            try {
                const marqueeElement = containerElement.querySelector('.marquee_mode-2');
                if (marqueeElement && jQuery(marqueeElement).length) {
                    // Check if already initialized
                    if (jQuery(marqueeElement).data('marquee')) {
                        return;
                    }

                    jQuery(marqueeElement).marquee({
                        speed: 20,
                        gap: 20,
                        delayBeforeStart: 0,
                        direction: 'left',
                        duplicated: true,
                        pauseOnHover: true,
                        startVisible: true,
                    });
                }
            } catch (error) {
            }
        }, 100);
    };

    // Start initialization
    initMarquee();
}

